<template>
  <div class="flex justify-end gap-2">
    <EasyBtn
      v-if="!hideCancelBtn"
      :variant="VuetifyBtnVariants.Outlined"
      :size="VuetifySizes.Small"
      :disabled="props.loading"
      data-cy="footer-btn__cancel"
      class="capitalize"
      @click="emit('close:clicked')"
    >
      {{ props.cancelBtnLabel || t("button_cancel") }}
    </EasyBtn>

    <EasyBtn
      ref="confirmBtnRef"
      :variant="VuetifyBtnVariants.Flat"
      :color="VuetifyColors.Primary"
      :size="VuetifySizes.Small"
      :disabled="props.okDisabled"
      :loading="props.loading"
      data-cy="footer-btn__confirm"
      class="capitalize"
      @click="emit('ok:clicked')"
    >
      {{ props.confirmBtnLabel || t("button_save") }}
    </EasyBtn>
  </div>
</template>

<script setup lang="ts">
import { VuetifyBtnVariants, VuetifyColors, VuetifySizes } from "@/src/easy-ui/types";
import { onMounted, ref } from "vue";
import EasyBtn from "@/src/easy-ui/components/EasyBtn.vue";

interface Props {
  cancelBtnLabel?: string;
  confirmBtnLabel?: string;
  loading?: boolean;
  okDisabled?: boolean;
  hideCancelBtn?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  okDisabled: false,
  cancelBtnLabel: "",
  confirmBtnLabel: "",
  hideCancelBtn: false,
});

interface Emits {
  (e: "ok:clicked"): void;
  (e: "close:clicked"): void;
}

const emit = defineEmits<Emits>();

const confirmBtnRef = ref<typeof EasyBtn>();

onMounted(() => {
  confirmBtnRef.value?.$el.focus();
});

const t = window.EasyLocale.getLocale;
</script>
